import { resolveStoneHandlingMode } from "./format.js";
export function activeDeliveryItems(source) {
    return (source?.items ?? []).filter((item) => !item.deletedAt);
}
export function newDeliveryItem(input) {
    return {
        id: crypto.randomUUID(),
        description: input.description?.trim() || null,
        staffComment: null,
        createdByUid: input.createdByUid,
        deletedAt: null,
        deletedByUid: null,
        // Firestore refuses undefined, so an uncharged item stores an explicit null.
        stoneRemovalCharge: null,
        createdAt: input.now,
        updatedAt: input.now,
    };
}
/**
 * Stamps the charge the customer's own stone-handling answer implies, so staff start from what was
 * asked for rather than re-reading the request item by item.
 *
 * What we charge for is read through `resolveStoneHandlingMode` — the one resolution every screen
 * already labels the delivery by — so the money can never be narrower than what staff and the
 * customer are being told we will do. That matters for the two answers only the resolver
 * understands: a details-less `REMOVE_AND_RETURN`, and the legacy `REMOVE_ALL`, both of which read
 * as goldsmith removal everywhere they are shown.
 *
 * An index naming no item is ignored: the selection was made against the list the customer typed,
 * which staff may since have edited. A charge already on an item is left alone — staff looking at
 * the piece outrank the request form, and pavé is a judgement only they can make.
 */
export function markRequestedStoneRemoval(items, source) {
    const mode = resolveStoneHandlingMode(source);
    if (mode !== "REMOVE_ALL_GOLDSMITH" && mode !== "SPECIFIC")
        return items;
    const selected = new Set(source.stoneHandlingDetails?.selectedItemIndexes ?? []);
    return items.map((item, index) => mode === "REMOVE_ALL_GOLDSMITH" || selected.has(index)
        ? { ...item, stoneRemovalCharge: item.stoneRemovalCharge ?? "STONE_REMOVAL" }
        : item);
}
